<template>
  <div>
    <v-chart
      :option="polar"
      autoresize
      :style="{ height: '320px', width: '100%' }"
    />
  </div>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart } from 'echarts/charts'
import { LegendComponent } from 'echarts/components'
import {
  GridComponent,
  MarkPointComponent,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  VisualMapComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

import variables from '@/styles/variables.scss'

use([
  LegendComponent,
  CanvasRenderer,
  BarChart,
  LineChart,
  GridComponent,
  MarkPointComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent
])
export default {
  components: {
    VChart
  },
  props: {
    title: String,
    xAxis1: Object,
    data1: Object,
    data2: Object,
    data3: Object,
    totalPercent: Number
  },
  data() {
    return {
      polar: {}
    }
  },
  created() {
    this.chart()
  },
  watch: {
    'xAxis1.data': {
      handler() {
        this.chart()
      }
    }
  },
  methods: {
    chart() {
      this.polar = {
        textStyle: {
          fontFamily: variables.fontFamily
        },
        color: [
          variables.grayColor,
          this.$getChatColor[0],
          this.$getVoiceColor[0]
        ],
        title: {
          text: this.title,
          left: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            let text = `${params[0].name} <br />`

            for (let i = 0; i < params.length; i++) {
              let value = params[i].value.toLocaleString()
              if (i > 0) {
                value = `${params[i].value.toFixed(2)}%`
              }

              text += `<ul><li class="li1">${params[i].marker} ${params[i].seriesName}</li> <li class="li2">${value}</li></ul>`
            }
            return text
          }
        },
        legend: {
          top: 'bottom'
        },
        grid: {
          height: 160
        },
        xAxis: [this.xAxis1],
        yAxis: [
          {
            type: 'value',
            scale: true,
            show: false,
            // name: 'Price',
            // max: 30,
            min: 0,
            boundaryGap: [0.2, 0.2]
          },
          {
            type: 'value',
            scale: true,
            max: 100,
            min: 0,
            interval: 20,
            boundaryGap: [0.2, 0.2],
            axisLabel: {
              formatter: function(value) {
                return `${value}.00%`
              }
            }
          }
        ],
        series: [
          this.data1,
          this.data2,
          {
            name: this.data3.name,
            type: 'line',
            lineStyle: {
              width: 1
            },
            yAxisIndex: 1,
            showSymbol: false,
            data: this.data3.data,
            markPoint: {
              data: [
                {
                  value: this.data3.data[0],
                  xAxis: this.data3.data.length - 1,
                  yAxis: this.data3.data[0]
                }
              ],
              symbol: 'pin',
              symbolSize: 60,
              symbolRotate: 270,
              // symbolOffset: [100, 0],
              label: {
                position: 'inside',
                offset: [6, 6],
                fontSize: 12,
                formatter: params => {
                  return `${params.value.toFixed(2)}%`
                }
              }
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep ul {
  list-style: none;
}
::v-deep .li1 {
  display: inline-block;
  width: 200px;
  text-align: left;
}
::v-deep .li2 {
  display: inline-block;
  width: 70px;
  text-align: left;
}
</style>
